import { useMutation, useQuery } from "@tanstack/react-query";
import useAxiosInstance from "./axiosInstance.utils";
import { errorFormat } from "./handleError.utils";
import { onSuccessMessage, queryClient } from "./reactQuery.utils";

/**
 * :::::::MUTATIONS:::::::::::
 */

export function useCreatePermissionMutation(keyData) {
  const { postApi } = useAxiosInstance();

  async function createPermissionApi(data) {
    try {
      const api = `/permission`;
      const apiResponse = await postApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["createPermissionApi", ...keyData],
    mutationFn: (data) => createPermissionApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("permissions");
      onSuccessMessage(data, 201);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, createPermission: mutateAsync };
}

export function useUpdatePermissionMutation(keyData) {
  const { putApi } = useAxiosInstance();
  async function updatePermissionApi({ id, ...data }) {
    try {
      const api = `/permission/${id}`;
      const apiResponse = await putApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["updatePermissionApi", ...keyData],
    mutationFn: (data) => updatePermissionApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("permissions");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, updatePermission: mutateAsync };
}

export function useDeletePermissionMutation(keyData) {
  const { deleteApi } = useAxiosInstance();
  async function deletePermissionApi(id) {
    try {
      const api = `/permission/${id}`;
      const apiResponse = await deleteApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["deletePermissionApi", ...keyData],
    mutationFn: (data) => deletePermissionApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("permissions");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, deletePermission: mutateAsync };
}

/**
 * :::::::QUERIES:::::::::::
 */
export function useGetAllPermissionQuery({ query = ``, options = {}, key = `` }) {
  const { getApi } = useAxiosInstance();
  async function getAllPermissionApi(q) {
    try {
      const api = `/permissions${q ?? ""}`;
      const apiResponse = await getApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { data, isPending: loading } = useQuery({
    queryKey: [`getAllPermission-${query ?? ""}${key ? "-" + key : ""}`],
    queryFn: () => getAllPermissionApi(query),
    ...options
  });
  const newData = data?.data?.permissions ?? {};
  return { data: newData, loading };
}
